/**
 * 协议类型字典
 */
export const agreementTypeEnum = [
  { label: '全部', value: ' ' },
  { label: '隐私协议', value: 1 },
  { label: '注册协议', value: 2 },
  { label: '关于我们', value: 3 }
]

/**
 * 协议新增or更新
 */
export const ROUTER_AGREEMENT_ADD_OR_UPDATE  = '/content/agreement/add'

/**
 * 协议列表
 */
export const ROUTER_AGREEMENT_LIST = '/content/agreement/list'

/**
 * 查看协议
 */
export const ROUTER_AGREEMENT_VIEW = '/content/agreement/view'
